import React, { useContext, useRef, useState } from 'react'
import { UserContext } from '../context/UserContext'
import { Form, Button, Col, Row } from 'react-bootstrap'
import { InputText } from 'primereact/inputtext'
import { Toast } from 'primereact/toast'
import css from './AnuncioForm.module.css'
import { Formik } from 'formik'
import Fuels from './camposForm/Fuels'
import Segments from './camposForm/Segments'
import Powers from './camposForm/Powers'
import Versions from './camposForm/Versions'
import Models from './camposForm/Models'
import Years from './camposForm/Years'
import Makes from './camposForm/Makes'
import { linkApi } from '../config'

export default function AnuncioForm() {
    const { user } = useContext(UserContext)
    const [dadosAnuncio, setDadosAnuncio] = useState([])
    const toast = useRef(null)

    const onSubmit = async (values) => {
        const options = {
            method: 'PUT',
            headers: {
                Authorization: 'Bearer ' + user.token,
            },
        }

        await fetch(
            `${linkApi}/v1/cars/editar-anuncio/?uuid=${values.id}&version=${values.version.id}`,
            options
        )
            .then((response) => response.json())
            .then((response) => {
                if (response.status === 200) {
                    setDadosAnuncio([])
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Alteração efetuada com sucesso',
                        life: 3000,
                    })
                } else {
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Warning',
                        detail: 'Houve um problema, contacte o suporte',
                        life: 3000,
                    })
                }
            })
            .catch((err) => console.error(err))
    }

    async function handleClick(e) {
        const options = {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + user.token,
            },
        }

        const res = await fetch(
            `${linkApi}/v1/cars/anuncio/` + e.target.value,
            options
        )
            .then((response) => response.json())
            .catch((err) => console.error(err))

        if (res.status === 200) {
            setDadosAnuncio(res.data)
        } else {
            setDadosAnuncio([])
        }
    }

    console.log('dadosAnuncio', dadosAnuncio)

    return (
        <>
            <div className={css.atividadeCard}>
                <div style={{ marginTop: '40px', marginBottom: '40px' }}>
                    <span className={css.title}>Editor de Anúncios</span>
                </div>
                <div
                    className="flex flex-column gap-2"
                    style={{ display: 'flex', marginBottom: '50px' }}
                >
                    <span className={css.title} htmlFor="anuncio">
                        ID do Anúncio
                    </span>
                    <InputText id="anuncio" onChange={(e) => handleClick(e)} />
                </div>
                <Toast ref={toast} />
                {dadosAnuncio.length !== 0 ? (
                    <Formik
                        enableReinitialize
                        initialValues={dadosAnuncio}
                        onSubmit={(val, { resetForm }) => {
                            console.log('val', val)
                            resetForm()
                            onSubmit(val)
                        }}
                    >
                        {({ values, handleSubmit, setFieldValue }) => {
                            return (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Row xs={1} lg={3}>
                                        <Makes values={values.make.name} />
                                        <Models
                                            values={values}
                                            setFieldValue={setFieldValue}
                                        />
                                        <Years
                                            values={values}
                                            setFieldValue={setFieldValue}
                                        />
                                        <Fuels
                                            values={values}
                                            setFieldValue={setFieldValue}
                                        />

                                        <Segments
                                            values={values}
                                            setFieldValue={setFieldValue}
                                        />
                                        <Powers
                                            values={values}
                                            setFieldValue={setFieldValue}
                                        />
                                        <Versions
                                            values={values}
                                            setFieldValue={setFieldValue}
                                        />
                                    </Row>
                                    <Row
                                        style={{
                                            marginTop: '15px',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <Col xs={'auto'}>
                                            <Button type="submit">
                                                Submit form
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            )
                        }}
                    </Formik>
                ) : (
                    <div> Inserir ID do Anuncio</div>
                )}
            </div>
        </>
    )
}
